(function () {
  var TGTP_TENANTS = window.__tgtpTenantData || {};
  var tenant = window.__tgtpResolvedTenant || '';
  var isHomePage = window.__tgtpIsHome || false;

  // Liquid 側で解決済みのテナントが tenantData に存在しない場合はフォールバック
  if (tenant && !TGTP_TENANTS[tenant]) {
    tenant = '';
  }
  if (!tenant && TGTP_TENANTS['top']) {
    tenant = 'top';
  }

  // CSS 変数を適用
  if (tenant) {
    var cfg = TGTP_TENANTS[tenant];
    var useHome = (isHomePage && cfg.home);
    var colors = useHome ? cfg.home : cfg;

    var root = document.documentElement.style;
    function apply(key, cssVar, wrap) {
      var v = colors[key];
      if (v) {
        root.setProperty(cssVar, wrap ? wrap(v) : v);
      }
    }
    apply('header', '--tgtp-color-header');
    apply('on_header', '--tgtp-color-on-header');
    apply('on_header_transparent', '--tgtp-color-on-header-transparent');
    apply('primary', '--tgtp-color-primary');
    apply('surface', '--tgtp-color-surface');
    apply('on_surface', '--tgtp-color-on-surface');
    apply('on_primary', '--tgtp-color-on-primary');
    apply('outline', '--tgtp-color-outline');
    apply('secondary', '--tgtp-color-secondary');
    apply('on_secondary', '--tgtp-color-on-secondary');
    apply('danger', '--tgtp-color-danger');
    apply('container', '--tgtp-color-container');
    apply('on_container', '--tgtp-color-on-container');
    apply('surface_scrim', '--tgtp-color-surface-scrim');
    apply('on_surface_scrim', '--tgtp-color-on-surface-scrim');
    apply('footer', '--tgtp-color-footer');
    apply('on_footer', '--tgtp-color-on-footer');
    apply('disabled', '--tgtp-color-disabled');
    apply('on_disabled', '--tgtp-color-on-disabled');
    apply('bg_image', '--tgtp-bg-image', function (v) { return 'url(' + v + ')'; });
    apply('bg_image_mobile', '--tgtp-bg-image-mobile', function (v) { return 'url(' + v + ')'; });

    // ヘッダー背景: 透過 > グラデーション > ヘッダー背景色 (--tgtp-color-header)
    var headerBackground = '';
    if (colors.header_transparent) {
      headerBackground = 'transparent';
    } else if (colors.header_gradient) {
      headerBackground = colors.header_gradient;
    }
    if (headerBackground) {
      root.setProperty('--tgtp-header-background', headerBackground);
      // 透過/グラデーション時は main を画面 0 から始めるためスペーサーを潰す
      root.setProperty('--tgtp-header-spacer-height', '0');
      // 透過/グラデ時はヘッダーバーの文字色を on_header_transparent に切替える
      // （実際の切替は CSS 側。dropdown 展開中は通常の on_header へ戻す）
      if (colors.on_header_transparent) {
        document.documentElement.classList.add('tgtp-header-transparent-text');
      }
    }

    // 背景の固定方法 / 繰り返し (per-tenant)。未設定ならグローバル設定 (CSS var の fallback) を使う
    if (colors.background_attachment) {
      var bgPosition = colors.background_attachment === 'scroll' ? 'absolute' : 'fixed';
      root.setProperty('--tgtp-bg-position', bgPosition);
      var bgRepeat = colors.background_attachment === 'scroll'
        ? (colors.background_repeat || 'no-repeat')
        : 'no-repeat';
      root.setProperty('--tgtp-bg-repeat', bgRepeat);
    }
  }

  window.__tgtpTenant = tenant;
  window.__tgtpTenants = TGTP_TENANTS;
})();
